(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hy-pagination"] && !Shopify.designMode) return;
  try {
    class HyPagination extends HTMLElement {
    constructor() {
      super();
    }
    loadNext() {
      const newURL = new URL(this.nextButton.href, location.origin);
      newURL.searchParams.set('section_id', this.sectionId);
      this.nextButton.textContent = this.nextButton.dataset?.loading;
      fetch(newURL.href)
      .then(res => res.text())
      .then(res => {
        if(!res) {
          throw new Error('no section content fetched!');
        }
        const template = document.createElement('template');
        template.innerHTML = res.trim();
        const newProductGrid = template?.content?.querySelector('#product-grid');
        const newPagination = template?.content?.querySelector('hy-pagination');
        if(newProductGrid) {
          this.productGrid?.insertAdjacentHTML('beforeend', newProductGrid.innerHTML);
        }
        if(newPagination) {
          const newText = newPagination?.querySelector('.hy-pagination-progress-text').textContent;
          const newProgress = newPagination?.querySelector('.hy-pagination-progress-bar')?.style?.getPropertyValue('--progress');
          const newButton = newPagination?.querySelector('.hy-pagination-next');
          if(newText) {
            this.querySelector('.hy-pagination-progress-text').textContent = newText;
          }
          if(newProgress) {
            this.querySelector('.hy-pagination-progress-bar')?.style?.setProperty("--progress", newProgress);
          }
          if(newButton) {
            this.nextButton.href = newButton.href;
            this.nextButton.textContent = newButton.textContent;
          } else {
            this.nextButton.remove();
          }
        }
        template.remove();
      }).catch(err => {
        this.nextButton.textContent = this.nextButtonText;
        console.error(err);
      });
    }
    connectedCallback() {
      this.section = this.closest('.shopify-section');
      this.productGrid = this.section.querySelector('#product-grid');
      this.sectionId = this.section?.id?.split('shopify-section-')?.pop();
      if(!this.sectionId) {
        return;
      }
      this.nextButton = this.querySelector('.hy-pagination-next');
      this.nextButtonText = this.nextButton.textContent;
      if(!this.nextButton?.href) {
        return;
      }
      this.nextButton?.addEventListener('click', e => {
        e.stopImmediatePropagation();
        e.preventDefault();
        this.loadNext();
      });
    }
  }
  window.customElements?.define("hy-pagination", HyPagination);
  } catch(e) { console.error(e); }
})();

})();
